export default "__VITE_ASSET__CrJaTvyJ__"